// aqui preciso adicionar as funcionalidades que o plano ativo tem que estão em functions
// preciso mostrar as customizações que o clube tem que estão em customs
// montar as regras dos clubes que vendem e que nao vendem

import {
    Autocomplete,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Paper,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import server from '../../../../services/server';
import { useFetch } from '../../../../hooks/useFecth';
import { useParams } from 'react-router-dom';
import useDialog from '../../../../hooks/useDialog';
import { useFormik } from 'formik';
import useErrors from '../../../../hooks/useErrors';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FormControlLabel, Switch } from '@mui/material';
import { DialogSale } from '../../Proposal';
import SelectPlan from '../../../../components/SelectPlan';
import AddIcon from '@mui/icons-material/Add';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import { useConfirm } from 'material-ui-confirm';
import { PriceInputMasked } from '../../../../components/PriceMask';
import ClubTabLayout from './ClubTabLayout';

const statuses = {
    PENDING: { label: 'Pendente', color: 'warning' },
    RECEIVED: { label: 'Recebida', color: 'info' },
    CONFIRMED: { label: 'Confirmada', color: 'success' },
    OVERDUE: { label: 'Atrasada', color: 'error' },
    REFUNDED: { label: 'Estornada', color: 'default' },
    DELETED: { label: 'Removida', color: 'default' },
    CANCELED: { label: 'Cancelada', color: 'default' },
    EXPIRED: { label: 'Expirada', color: 'default' },
    PENDING_REFUND: { label: 'Pendente de Estorno', color: 'default' },
    REFUND_FAILED: { label: 'Estorno Falhou', color: 'default' },
    REFUND_IN_PROGRESS: { label: 'Estorno em Progresso', color: 'default' },
    REFUND_PENDING: { label: 'Estorno Pendente', color: 'default' },
};

function DialogCreateContract({ data, mutate }) {
    const { open, handleClose } = useDialog('#create-contract');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { data: plans } = useFetch(`plans`, {
        params: { paged: false },
    });

    const { values, handleSubmit, getFieldProps, setFieldValue, errors, setValues, isSubmitting } = useFormik({
        initialValues: {
            contractType: '',
            startDate: '',
            endDate: '',
            description: '',
            planId: '',
            functions: '',
            plan: ``,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                // Aqui você pode implementar a lógica para criar o contrato
                await server.post(`subscription/migratedClub`, { clubId, ...values });
                enqueueSnackbar(`Contrato criado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    // Selected plan details to reflect in inputs when plan changes
    const [selectedPlan, setSelectedPlan] = React.useState(null);

    // Handle plan change: set form field and fetch plan details
    const handlePlanChange = async ({ target: { value } }) => {
        try {
            await setFieldValue('planId', value, false);
            if (!value) {
                setSelectedPlan(null);

                return;
            }
            const { data } = await server.get(`plans/${value}`);
            // API may return either { data: {...} } or raw object; normalize
            const plan = data?.data || data;
            setSelectedPlan(plan || null);

            setValues(prev => ({
                ...prev,
                plan,
                functions: plan?.functions || '',
                planId: plan.id,
            }));
        } catch (error) {
            setErrors(error);
        }
    };
 

    // const hasCoupons = selectedPlan?.functions?.includes('cupons');
    // const hasVouchers = selectedPlan?.functions?.includes('vouchers');
    // const hasCashback = selectedPlan?.functions?.includes('cashback');
    // const hasMultiApp = selectedPlan?.functions?.includes('multi_app');
    // const hasCustomApp = selectedPlan?.functions?.includes('custom_app');
    // const hasReseller = selectedPlan?.functions?.includes('reseller');
    // const hasBenefit = selectedPlan?.functions?.includes('benefit');

    // const hasTelePsicologia = selectedPlan?.additionals?.includes("telepsicologia");
    // const hasSeguro =  selectedPlan?.additionals?.includes("seguro");
    // const hasTeleMedicina= selectedPlan?.additionals?.includes("telemedicina");

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Criar Novo Contrato</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 2 }}>
                    <SelectPlan
                        {...getFieldProps('planId')}
                        onChange={handlePlanChange}
                        valueSelected={values.planId}
                        fullWidth
                        error={!!errors.planId}
                        helperText={errors.planId}
                    />
                    {/*
                    {Boolean(selectedPlan) && (
                        <>
                            {values.functions}
                            <ToggleButtonGroup
                                fullWidth
                                onChange={(e, value) => setFieldValue('functions', value)}
                                value={values.functions}
                                name="functions"
                            >
                                <ToggleButton   sx={{ fontSize: 11 }} disabled={!hasCoupons} value="cupons">
                                    Rede de descontos
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasVouchers} value="vouchers">
                                    Rede local
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasCashback} value="cashback">
                                    Cashback
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasMultiApp} value="multi_app">
                                    App Seu Clube
                                </ToggleButton>
                                <ToggleButton   sx={{ fontSize: 11 }} disabled={!hasCustomApp} value="custom_app">
                                    App Personalizado
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasReseller} value="reseller">
                                    Revenda/Página de vendas
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasBenefit} value="benefit">
                                    Gestão de benefícios
                                </ToggleButton>
                            </ToggleButtonGroup>

                            {selectedPlan?.functions?.includes('benefit') && (
                                <ToggleButtonGroup
                                    fullWidth
                                    onChange={(e, value) => setFieldValue('additionals', value)}
                                    value={values.additionals}
                                    name="additionals"
                                >
                                    <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasTeleMedicina} value="telemedicina">
                                        Telemedicina
                                    </ToggleButton>
                                    <ToggleButton    sx={{ fontSize: 11 }} disabled={!hasTelePsicologia}  value="telepsicologia">
                                        Telepsicologia
                                    </ToggleButton>
                                    <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasSeguro} value="seguro">
                                        Seguro de vida
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        </>
                    )}*/}
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Criando...' : 'Criar Contrato'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogUpdateContract({ data, mutate }) {
    const { open, handleClose } = useDialog('#update-contract');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { data: plans } = useFetch(`plans`, {
        params: { paged: false },
    });

    const { values, handleSubmit, getFieldProps, setFieldValue, errors, setValues, isSubmitting } = useFormik({
        initialValues: {
            contractType: '',
            startDate: '',
            endDate: '',
            description: '',
            planId: '',
            functions: '',
            plan: ``,
            additionals: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                // Aqui você pode implementar a lógica para criar o contrato
                await server.put(`subscription/club/${clubId}/functions`, { ...values });
                enqueueSnackbar(`Contrato criado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ functions: data?.functions, additionals: data?.additionals });
        };
    }, [data]);

    // function functionsVerify(value) { 
    //     return data?.functions?.includes(value);
    // };
    // function additionalsVerify(value) { 
    //     return data?.additionals?.includes(value);
    // }; 

    function handleAdditionalChange(e, value){
        setFieldValue('functions', value);

        if (!value.includes('benefit')) {
          setFieldValue('additionals', []);
        }else { 
          setFieldValue('additionals',  data?.additionals);
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Alterar plano</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 2 }}>
                    {/* <SelectPlan
                        {...getFieldProps('planId')}
                        onChange={handlePlanChange}
                        valueSelected={values.planId}
                        fullWidth
                        error={!!errors.planId}
                        helperText={errors.planId}
                    /> */}
                    <ToggleButtonGroup
                        fullWidth
                        // onChange={(e, value) => setFieldValue('functions', value)}
                        onChange={handleAdditionalChange}
                        value={values?.functions}
                        name="functions"

                    >
                        <ToggleButton sx={{ fontSize: 11 }}   value="cupons">
                            Rede de descontos
                        </ToggleButton>
                        <ToggleButton sx={{ fontSize: 11 }}  value="vouchers">
                            Rede local
                        </ToggleButton>
                        <ToggleButton sx={{ fontSize: 11 }}  value="cashback">
                            Cashback
                        </ToggleButton>
                        <ToggleButton sx={{ fontSize: 11 }}  value="multi_app">
                            App Seu Clube
                        </ToggleButton>
                        <ToggleButton sx={{ fontSize: 11 }}  value="custom_app">
                            App Personalizado
                        </ToggleButton>
                        <ToggleButton sx={{ fontSize: 11 }}  value="reseller">
                            Revenda/Página de vendas
                        </ToggleButton>
                            
                            <ToggleButton    sx={{ fontSize: 11 }}  value="benefit">
                            Gestão de benefícios
                        </ToggleButton>
                    </ToggleButtonGroup>

                    {values?.functions?.includes('benefit') && (
                        <ToggleButtonGroup
                            fullWidth
                            onChange={(e, value) => setFieldValue('additionals', value)}


                            value={values?.additionals}
                            // disabled={!values?.functions?.includes('benefit')}
                            name="additionals"
                            multiple 
                        >
                            <ToggleButton sx={{ fontSize: 11 }} value="telemedicina">
                                Telemedicina
                            </ToggleButton>
                            <ToggleButton sx={{ fontSize: 11 }} value="telepsicologia">
                                Telepsicologia
                            </ToggleButton>
                            <ToggleButton u sx={{ fontSize: 11 }} value="seguro">
                                Seguro de vida
                            </ToggleButton>
                        </ToggleButtonGroup>
                    )}
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Alterando...' : 'Alterar Plano'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogInvoices({ clubId }) {
    const { open, handleClose } = useDialog('#invoices');
    const { data, isLoading } = useFetch(`clubs/${clubId}`);

    if (isLoading) return <></>;

    if (!data) return null;

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Histórico de Faturas</DialogTitle>
            <Divider />
            <DialogContent>
                <List>
                    {data?.invoces?.map(invoice => (
                        <ListItem key={invoice.id}>
                            <ListItemText
                                primary={`Fatura #${invoice.id}`}
                                secondary={
                                    <Stack gap={1}>
                                        <Typography variant="body2">
                                            Data de Vencimento: {format(new Date(invoice.dueDate), 'dd/MM/yyyy', { locale: ptBR })}
                                        </Typography>
                                        <Typography variant="body2">
                                            Status:{' '}
                                            <Chip
                                                label={statuses[invoice?.status]?.label || 'Processando'}
                                                color={statuses[invoice?.status]?.color || 'default'}
                                            />
                                        </Typography>
                                        {invoice.paymentDate && (
                                            <Typography variant="body2">
                                                Data de Pagamento: {format(new Date(invoice.paymentDate), 'dd/MM/yyyy', { locale: ptBR })}
                                            </Typography>
                                        )}
                                    </Stack>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogStatus({ data, mutate }) {
    const { open, handleClose } = useDialog('#status');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { values, handleSubmit, setValues, isSubmitting } = useFormik({
        initialValues: {
            status: false,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, { status: values.status });
                enqueueSnackbar(`Status do clube alterado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ status: data.status });
        }
    }, [data]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Alterar Status do Clube</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <FormControlLabel
                        control={<Switch checked={values.status} onChange={e => setValues({ status: e.target.checked })} />}
                        label={values.status ? 'Ativo' : 'Inativo'}
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function formatResellerPrice(value) {
    return Number(value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function DialogAddResellerProduct({ linkedProducts, mutate }) {
    const { open, handleClose } = useDialog('#add-reseller-product');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();
    const { data: catalogRaw, isLoading: catalogLoading } = useFetch(
        open ? 'additional?paged=false&status=true&type=additional' : null,
    );

    const catalog = useMemo(() => {
        const rows = Array.isArray(catalogRaw) ? catalogRaw : catalogRaw?.data || [];
        const activeIds = new Set(
            (linkedProducts || [])
                .filter(item => !item.disabled)
                .map(item => Number(item.productId))
                .filter(Boolean),
        );
        return rows.filter(product => !activeIds.has(Number(product.id)));
    }, [catalogRaw, linkedProducts]);

    const { values, setFieldValue, handleSubmit, getFieldProps, resetForm, isSubmitting } = useFormik({
        initialValues: {
            productId: '',
            name: '',
            price: '',
            type: '',
            additionalType: '',
            description: '',
            numberDependents: 0,
        },
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                if (!formValues.productId) {
                    enqueueSnackbar('Selecione um produto do catálogo.', { variant: 'warning' });
                    return;
                }
                setSubmitting(true);
                await server.post(`clubs/${clubId}/reseller_products`, {
                    productId: Number(formValues.productId),
                    name: formValues.name,
                    price: Number(formValues.price || 0),
                    type: formValues.additionalType || formValues.type,
                    additionalType: formValues.additionalType || formValues.type,
                    description: formValues.description,
                    numberDependents: Number(formValues.numberDependents || 0),
                });
                enqueueSnackbar('Produto de revenda adicionado.');
                await mutate();
                resetForm();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    const selectedProduct = catalog.find(item => Number(item.id) === Number(values.productId)) || null;

    const handleSelectProduct = (_event, product) => {
        if (!product) {
            resetForm();
            return;
        }
        setFieldValue('productId', product.id);
        setFieldValue('name', product.name || '');
        setFieldValue('price', product.price ?? 0);
        setFieldValue('type', product.type || '');
        setFieldValue('additionalType', product.additionalType || '');
        setFieldValue('description', product.description || '');
        setFieldValue('numberDependents', product.numberDependents ?? 0);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            TransitionProps={{
                onExited: () => resetForm(),
            }}
        >
            <DialogTitle>Adicionar produto de revenda</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 2 }}>
                    <Autocomplete
                        options={catalog}
                        loading={catalogLoading}
                        value={selectedProduct}
                        getOptionLabel={option => option?.name || ''}
                        isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                        onChange={handleSelectProduct}
                        renderInput={params => <TextField {...params} label="Produto do catálogo" />}
                        noOptionsText="Nenhum produto disponível para vincular"
                    />
                    <TextField label="Nome" value={values.name} InputProps={{ readOnly: true }} fullWidth />
                    <TextField
                        {...getFieldProps('price')}
                        label="Preço de revenda"
                        fullWidth
                        value={values.price}
                        InputProps={{ inputComponent: PriceInputMasked }}
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting || !values.productId}>
                    {isSubmitting ? 'Adicionando...' : 'Adicionar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogEditResellerProduct({ product, mutate }) {
    const { open, handleClose } = useDialog('#edit-reseller-product');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();
    const confirm = useConfirm();

    const { values, setValues, handleSubmit, getFieldProps, setFieldValue, errors, isSubmitting } = useFormik({
        initialValues: {
            name: product?.name || product?.Product?.name || '',
            description: product?.description || product?.Product?.description || '',
            price: product?.price || product?.Product?.price || '',
            type: product?.type || '',
            image: product?.image || product?.Product?.image || '',
            disabled: Boolean(product?.disabled),
            clickLifePlanId: product?.clickLifePlanId || '',
        },
        enableReinitialize: true,
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                if (formValues.disabled && !product?.disabled) {
                    await confirm({
                        title: 'Desabilitar produto de revenda',
                        description: `O produto "${formValues.name || product?.name}" deixará de ficar disponível para o clube. Você pode reativá-lo depois.`,
                        confirmationText: 'Desabilitar',
                        cancellationText: 'Cancelar',
                    });
                }
                setSubmitting(true);
                await server.put(`clubs/${clubId}/reseller_products/${product.id}`, {
                    price: Number(formValues.price || 0),
                    disabled: Boolean(formValues.disabled),
                    clickLifePlanId: String(formValues.clickLifePlanId || '').trim() || null,
                });
                enqueueSnackbar(`Produto atualizado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                if (error?.response) setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (product) {
            setValues({ ...product, disabled: Boolean(product.disabled) });
        }
    }, [product, setFieldValue]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Editar Produto de Revenda</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 2 }}>
                    <TextField
                        label="Nome do Produto"
                        value={values.name}
                        fullWidth
                        InputProps={{ readOnly: true }}
                    />
                    <TextField
                        {...getFieldProps('price')}
                        label="Preço"
                        fullWidth
                        value={values.price}
                        error={!!errors.price}
                        helperText={errors.price}
                        InputProps={{ inputComponent: PriceInputMasked }}
                    />
                    {(values.type === 'telemedicina' || product?.type === 'telemedicina' || product?.additionalType === 'telemedicina') && (
                        <TextField
                            {...getFieldProps('clickLifePlanId')}
                            label="Plano Click Life"
                            fullWidth
                            value={values.clickLifePlanId || ''}
                            helperText="Id do plano na Click Life. A inativação lê este valor no produto de revenda."
                        />
                    )}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={!values.disabled}
                                onChange={(_event, checked) => setFieldValue('disabled', !checked)}
                                color="primary"
                            />
                        }
                        label={values.disabled ? 'Inativo' : 'Ativo'}
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default function ResellerClub({ data: club }) {
    const { id: clubId } = useParams();
    const { data, isLoading, mutate } = useFetch(`clubs/${clubId}/reseller_products`);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const products = Array.isArray(data) ? data : [];
    const hasAsaas = Boolean(club?.hasAsaasKey);

    if (isLoading) return <>Carregando ... </>;

    return (
        <>
            <ClubTabLayout
                actions={
                    <>
                        <Chip
                            size="small"
                            icon={hasAsaas ? <CheckCircle /> : <Cancel />}
                            label={hasAsaas ? 'Asaas configurado' : 'Sem Asaas'}
                            color={hasAsaas ? 'success' : 'default'}
                            variant={hasAsaas ? 'filled' : 'outlined'}
                            sx={{ mr: 'auto' }}
                        />
                        <Button component="a" href="#add-reseller-product" variant="outlined" startIcon={<AddIcon />}>
                            Adicionar
                        </Button>
                    </>
                }
            >
                            {products.length === 0 ? (
                                <Typography variant="body2" color="text.secondary" sx={{ p: 3 }} textAlign="center">
                                    Nenhum produto de revenda vinculado a este clube.
                                </Typography>
                            ) : (
                                <List>
                                    {products.map((product, index) => (
                                        <React.Fragment key={product.id || index}>
                                            <ListItem sx={{ opacity: product.disabled ? 0.6 : 1 }}>
                                                <ListItemText
                                                    primary={
                                                        <Stack direction="row" alignItems="center" gap={1}>
                                                            <Typography>
                                                                {product.id} | {product.name || product.Product?.name || 'Produto sem nome'}
                                                            </Typography>
                                                            {product.disabled && (
                                                                <Chip size="small" label="Desabilitado" color="default" />
                                                            )}
                                                        </Stack>
                                                    }
                                                    secondary={
                                                        <Typography variant="caption" color="text.secondary">
                                                            {`Preço: ${formatResellerPrice(product.price)}`}
                                                        </Typography>
                                                    }
                                                />
                                                <IconButton
                                                    component="a"
                                                    href={`#edit-reseller-product|${product.id || index}`}
                                                    color="primary"
                                                    onClick={() => setSelectedProduct(product)}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </ListItem>
                                            <Divider />
                                        </React.Fragment>
                                    ))}
                                </List>
                            )}
            </ClubTabLayout>
            <DialogSale mutate={mutate} />
            <DialogAddResellerProduct linkedProducts={products} mutate={mutate} />
            <DialogEditResellerProduct product={selectedProduct} mutate={mutate} />
        </>
    );
}
